let config = {};

config.baseURL = 'https://api.trial.innovareti.com.br/api/v1/';
config.normalURL = 'https://api.trial.innovareti.com.br/';

config.portalAdmin = 'https://trial.innovareti.com.br/';
config.apiInvitee = 'https://api.app.invitee.com.br/api/v1/';

export default config


// WEBPACK FOOTER //
// ./src/config/production.js